import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { useIntercom } from 'react-use-intercom';
import { api } from '../api';
import { intercomEvents } from '../intercom-events';
import queryClient from '../query-client';
import { PostResponseBody } from '../types/api-response';
import { FileRecord } from '../types/file-record';

export type CreateLinksRequest = { parentFolderId?: string; link: string; name: string }[];

async function createReferences(request: CreateLinksRequest): Promise<PostResponseBody<FileRecord>> {
    const { data } = await api.post('/file-records/links', request);
    return data;
}

export function useCreateLinks(): UseMutationResult<PostResponseBody<FileRecord>, AxiosError, CreateLinksRequest, unknown> {
    const { trackEvent } = useIntercom();
    return useMutation(createReferences, {
        onSettled: () => {
            queryClient.invalidateQueries(['file-records']);
            trackEvent(intercomEvents.file.link.event);
        },
    });
}
